var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShotEyesBlankInput = function SvgShotEyesBlankInput(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "shotEyesBlankInput_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".shotEyesBlankInput_svg__st0{fill:none;stroke:#333;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:2}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4H3v16h3",
    className: "shotEyesBlankInput_svg__st0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17 12H7",
    style: {
      fill: "none",
      stroke: "#333",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeMiterlimit: 2
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 4h3v16h-3",
    className: "shotEyesBlankInput_svg__st0"
  })));
};
export default SvgShotEyesBlankInput;